import React from 'react'
import { injectState } from 'freactal'
import styled from 'styled-components'
import { Grid, Cell, Card } from 'react-mdl'
import FullAreaContent from '../../components/FullAreaContent'
import Accordion, { Section } from '../../components/Accordion'
import Content from './Content'
import Introduction from './Introduction'
import Scenario from './Scenario'
import Tasks from './Tasks'

const StyledGrid = styled(Grid)`
  height: 100%;
  margin: 0;
  box-sizing: border-box;
  align-content: stretch;
`
const StyledAccordion = styled(Accordion)`
  padding: 1em;
`

export default injectState(AssessmentPlan)

function AssessmentPlan({
  state: { unit: { summativePracticalAssessments } },
}) {
  return (
    <FullAreaContent>
      <StyledAccordion>
        {summativePracticalAssessments.map((assessment, i) => (
          <Section
            key={assessment._id}
            header={`Assessment ${i + 1} - ${assessment.name}`}>
            <Card shadow={0} style={{ width: '100%' }}>
              <StyledGrid>
                <Cell col={4} style={{ position: 'relative' }}>
                  <Card shadow={0} style={{ padding: '1em', width: '100%' }}>
                    <h5>Final Practical Assessment</h5>
                    {assessment.introduction &&
                      <Introduction introduction={assessment.introduction} />}
                    {assessment.tasks && <Tasks tasks={assessment.tasks} />}
                    {assessment.scenario &&
                      <Scenario
                        introduction={assessment.scenario.introduction}
                        items={assessment.scenario.items}
                      />}
                  </Card>
                </Cell>
                <Cell col={8}>
                  <Content
                    summativePracticalAssessment={assessment}
                    summativePracticalAssessmentIndex={i}
                  />
                </Cell>
              </StyledGrid>
            </Card>
          </Section>
        ))}
      </StyledAccordion>
    </FullAreaContent>
  )
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/AssessmentPlan/index.js